import CarCrashedSvg from "@/components/error-page/_assets/car-crashed.svg?react";
import { ButtonSize, buttonVariants } from "@/components/ui/button";
import { Container } from "@/components/ui/container";
import { SCOPES } from "@/config/msal";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";

interface AuthenticationErrorViewProps {
  error?: Error;
}

export function AuthenticationErrorView({ error }: AuthenticationErrorViewProps) {
  const { t } = useTranslation(["common"]);
  const { instance, inProgress } = useMsal();

  const handleRetry = () => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }
    instance.loginRedirect({
      scopes: SCOPES.API,
    });
  };

  const errorMessage = error?.message
    ? t("common:AuthenticationErrorWithMessage", { message: error.message })
    : t("common:AuthenticationErrorGeneric");

  return (
    <div className="relative flex min-h-[calc(100vh-4rem)] items-center justify-center overflow-hidden p-4 sm:p-8">
      <div className="relative z-10 mx-auto max-w-4xl space-y-6 text-center sm:space-y-8">
        <div className="group flex justify-center">
          <CarCrashedSvg className="fill-primary/90 relative h-32 w-48 sm:h-56 sm:w-96" />
        </div>
        <Container className="space-y-4 sm:space-y-6">
          <div className="space-y-2 sm:space-y-3">
            <h1 className="text-primary p-2 text-5xl font-bold sm:text-7xl">401</h1>
            <h2 className="text-foreground/90 text-xl font-semibold sm:text-3xl">{t("common:AuthenticationError")}</h2>
          </div>

          <p className="text-muted-foreground mx-auto max-w-sm text-base leading-relaxed sm:max-w-4xl sm:text-lg">
            {errorMessage}
          </p>

          <div className="flex justify-center pt-4">
            <button
              type="button"
              onClick={handleRetry}
              disabled={inProgress !== InteractionStatus.None}
              className={buttonVariants({ size: ButtonSize.Lg })}
              aria-label={t("common:RetryLogin")}
            >
              {t("common:RetryLogin")}
            </button>
          </div>
        </Container>
      </div>
    </div>
  );
}
